import { Routes } from '@angular/router'

import { MediaLibraryApi } from '@flowx/designer/shared/api/media-library.api'

import { WorkspaceThemesPermissionsResolver } from './workspace.resolvers'

import { MEDIA_LIBRARY_API } from '../../core/dictionary/media-library.dictionary'
import { themeCanActivateGuard, themeCanDeactivateGuard } from '../../theme/guards'

export const WorkspaceEntityRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@flowx/designer/modules/layout/components/main-layout/main-layout.component').then(
        ({ MainLayoutComponent }) => MainLayoutComponent
      ),
    loadChildren: () =>
      import('./workspace-main-layout-routes').then(
        ({ WorkspaceMainLayoutRoutes }) => WorkspaceMainLayoutRoutes
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import(
        '@flowx/designer/modules/layout/components/access-management-main-layout/access-management-main-layout.component'
      ).then(({ AccessManagementMainLayoutComponent }) => AccessManagementMainLayoutComponent),
    loadChildren: () =>
      import('./workspace-entity-details-layout-routes').then(
        ({ WorkspaceEntityDetailsLayoutRoutes }) => WorkspaceEntityDetailsLayoutRoutes
      ),
  },
  {
    path: 'theme',
    canDeactivate: [themeCanDeactivateGuard],
    canActivate: [themeCanActivateGuard()],
    providers: [{ provide: MEDIA_LIBRARY_API, useClass: MediaLibraryApi }],
    children: [
      {
        path: ':id',
        resolve: { accessRights: WorkspaceThemesPermissionsResolver },
        loadComponent: () =>
          import('@flowx/designer//modules/theme/theme-page.component').then(
            ({ FlxThemePageComponent }) => FlxThemePageComponent
          ),
      },
    ],
  },
  {
    path: 'cms',
    loadChildren: () => import('@flowx/designer/modules/cms/cms.module').then((m) => m.CmsModule),
  },
]
